import {useNavigate} from "react-router-dom";
import {useEffect} from "react";

const Logout = () => {
    const navigate = useNavigate()

    useEffect(() => {
        localStorage.removeItem("accessToken")

        navigate("/")

        window.location.reload()
    })

    return (
        <>

        </>
    )
}

export default Logout;